import React, { useState, useEffect } from 'react';
import { ModalGap } from '../../../services/settings/appStyle/global.style';
import { Modal } from '../../../Components/uielements';

import {
  OptionItem,
  OptionList,
  UpdateDescription,
  FeatureContent,
  FeatureIcon,
  FeatureDetails,
  FeatureTitle,
  FeatureDescription,
  ModalTitleContainer,
  ModalWrapper,
  GotItButton,
} from './NewReleasedUpdate.style';
import { useQuery } from 'react-query';
import { getNewUpdateList } from '../../../services/bioplus-services/newReleasedUpdate';
import { useAuth } from '../../../hooks/AuthContext';

export const NewReleasedUpdate = ({ forceShow = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { session } = useAuth();

  // Current app version
  const CURRENT_VERSION = session?.webVersionNumber || '3.0.9';
  const LOCAL_STORAGE_KEY = 'lastSeenUpdateVersion';

  const { data: newReleasedUpdateList, isLoading } = useQuery('getNewUpdateList', () =>
    getNewUpdateList()
  );

  useEffect(() => {
    if (forceShow) {
      setIsOpen(true);
      return;
    }

    // Check if webUpdateSeen is 1 (true means update should be shown)
    if (session?.webUpdateSeen === 1) {
      const lastSeenVersion = localStorage.getItem(LOCAL_STORAGE_KEY);

      // Show modal if user hasn't seen this version yet
      if (!lastSeenVersion || lastSeenVersion !== CURRENT_VERSION) {
        setIsOpen(true);
      }
    }
  }, [forceShow, CURRENT_VERSION, session?.webUpdateSeen]);

  const handleClose = () => {
    // Mark this version as seen
    localStorage.setItem(LOCAL_STORAGE_KEY, CURRENT_VERSION);
    setIsOpen(false);
  };

  // Don't render if not open or still loading
  if (!isOpen || isLoading) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      // onClose={handleClose}
      title={<ModalTitleContainer>✨ What's New v{CURRENT_VERSION}</ModalTitleContainer>}
      isNotCapitalize={true}
    >
      <ModalWrapper>
        <ModalGap>
          <UpdateDescription>
            {newReleasedUpdateList?.description ||
              "Discover the latest features and improvements we've added for you!"}
          </UpdateDescription>

          <OptionList>
            <FeatureTitle>{newReleasedUpdateList?.title}</FeatureTitle>
            {newReleasedUpdateList?.featureList?.map((feature, index) => (
              <OptionItem key={`feature-${index}`}>
                <FeatureIcon>{'⚡'}</FeatureIcon>
                <FeatureContent>
                  <FeatureDetails>
                    <FeatureDescription>{feature}</FeatureDescription>
                  </FeatureDetails>
                </FeatureContent>
              </OptionItem>
            ))}
          </OptionList>
          <GotItButton onClick={handleClose}>Got It</GotItButton>
        </ModalGap>
      </ModalWrapper>
    </Modal>
  );
};

export default NewReleasedUpdate;
